export enum ETypeNotification {
    ERROR = 0,
    SUCCESS = 1,
    WARNING = 2,
    INFO = 3,
    ANYTHING = 4,
}